document.addEventListener('DOMContentLoaded', function () {
 const sectionId = 'shopify-section-template--27177763602731__image_banner_bXxbNY';
  const section = document.getElementById(sectionId);
  if (!section) return;

  const videoUrl = 'https://cdn.shopify.com/videos/c/o/v/b74b96c132ca4cf0b5d7d4ca1a32d2e5.mp4';

  const video = document.createElement('video');
  video.src = videoUrl;
  video.autoplay = true;
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');

  Object.assign(video.style, {
    position: 'absolute',
    top: '0', left: '0',
    width: '100%', height: '100%',
    objectFit: 'cover',
    zIndex: '10',
    pointerEvents: 'none'
  });

  section.style.position = 'relative';
  section.style.overflow = 'hidden';
  section.insertBefore(video, section.firstChild);

  section.querySelectorAll('.banner__content, .banner__box').forEach(el => {
    el.style.position = 'relative';
    el.style.zIndex = '1';
  });
});